import React from "react";
import {
  Space,
  Row,
  Col,
  message,
  Image,
  Button,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import EmailReportStore from "../store/EmailReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import EmailReportAdd from "./EmailReportAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class EmailReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.emailReportStore = new EmailReportStore();
    this.companyStore = new CompanyStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      companyVal_Lab: "",
      Id: "",
      listDataUpdate: false,
      openEmailAddForm: false,
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };

    this.columns = [
      {
        // title: "Email Details ",
        title: context.translate("_EMAIL_DETAILS_"),
        dataIndex: "emailId",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "CC Details",
        title: context.translate("_CC_DETAILS_"),
        dataIndex: "cc",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "CC Details",
        title: context.translate("_REPORT_NAME_"),
        dataIndex: "reportName",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed : 'right',
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        width: 10,
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={this.context.translate("_EDIT_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "19px",
                      width: "14px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip>
                <Tooltip
                  title={this.context.translate("_DELETE_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{
                      cursor: "pointer",
                      width: "14px",
                    }}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const emailStates = this.context.viewStateStore.emailReportObject;
      console.log(emailStates);
      if (emailStates.companyId !== "") {
        this.setState({ pageSize: 50 });
        await this.emailReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: emailStates.companyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          emailStates.companyId
        );

        console.log(singleData);
        await this.setState({
          companyVal_Lab: singleData,
        });
        await this.setState({ loadList: 1 });
      }
    }
  }

  async componentDidMount() {
    console.log(this.context.viewStateStore.value, "vale");
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async onDelete(record) {
    console.log(record.er_Id, "record");
    const response = await this.emailReportStore.deleteRecord({
      er_Id: record.er_Id,
    });
    console.log(response.data.success);
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  onEdit = async (record) => {
    console.log(record.er_Id);
    const id = record.er_Id;
    if (id) {
      this.context.viewStateStore.setEmailReportStates({
        companyId: record.companyId,
      });
      // this.props.navigate("/emailreportadd/" + id);
    }
    await this.setState({ Id: record.er_Id });
    await this.setState({ openEmailAddForm: true });
  };

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value, loadList: 1 });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });

    await this.handleSearch();
    this.setState({ loadList: 1 });
  };

  async handleSearch() {
    this.setState({ loading: true });
    await this.emailReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,

    });
    await this.setState({ loadList: 1 });
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openEmailAddForm: false });

      await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    } else {
      message.error(resp.message);
    }
  };

  closeModal = () => {
    this.setState({ openEmailAddForm: false, Id: "" });
  };

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.emailReportStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,

      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <CompanyAutocomplete
                className="searchInput"
                onChange={this.handleChange}
                value={
                  this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                }
                // allowClear={true}
                style={{ width: 200 }}
              />
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                {" "}
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              <Button
                className="addButtonClass"
                onClick={() =>
                  this.setState({ openEmailAddForm: true, Id: "" })
                }
              >
                <Image
                  style={{ width: 13, marginInlineEnd: "5px" }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.emailReportStore?.total}
            columns={this.columns}
            dataSource={this.emailReportStore?.emailStore}
            loading={this.emailReportStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openEmailAddForm && (
            // <Modal
            //   bodyStyle={{ height: "645px" }}
            //   className="formShowModal" //  {/* css class */}
            //   title={this.context.translate("_MAIL_SETTINGS_")}
            //   centered
            //   visible={this.state.openEmailAddForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openEmailAddForm: false, Id: "" });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openEmailAddForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_MAIL_SETTINGS_")}
                  <p className="formDescription">
                    {this.context.translate("_EMAIL_ADD_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openEmailAddForm: false })}
              onCancel={() =>
                this.setState({
                  openEmailAddForm: false,
                  Id: "",
                })
              }
            >
              <div style={{ height: "100%" }}>
                <EmailReportAdd
                  Id={this.state.Id}
                  response={this.responseMsg}
                  companyId={this.state.companyId}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
EmailReportList.contextType = StoreContext;
export default observer(withRouter(EmailReportList));
